import React from "react";
import classNames from "classnames/bind";
import styles from "./spinner.module.scss";

interface SpinnerProps {
  type?: "NORMAL" | "SECONDARY";
}

const Spinner: React.FC<SpinnerProps> = ({ type = "NORMAL" }) => {
  const cx = classNames.bind(styles);
  const spinnerClass = cx({
    normal: type === "NORMAL",
    secondary: type === "SECONDARY",
  });

  return <div className={spinnerClass} />;
};

export default Spinner;
